export const environment = {
  production: false,
    apiUrl: 'https://api.watchzaar.com', // URL del servidor local para desarrollo
  googleLoginUrl: 'https://api.watchzaar.com/oauth2/authorization/google',
};
